import { StatusCodes } from "http-status-codes"
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'uuid... Remove this comment to see the full error message
import { v4 as uuid } from "uuid"
import Settings from "../../../utils/CarrotConfig"
import { GeneratePaymentIntentResponse } from "../types/GeneratePaymentIntentResponse"
import { PaymentIntentArgs } from "../types/PaymentIntentArgs"
import StripeResponseError from "../types/StripeResponseError"

export default class InboundMemberPaymentsClient {
  async processJsonResponse<ResponseType>(response: Response, correlationId: string): Promise<ResponseType> {
    if (response.status === StatusCodes.OK) {
      return response?.json()
    }

    const buffer = await response.arrayBuffer()
    const text = new TextDecoder().decode(buffer)
    const data = JSON.parse(text)
    if (data && data.error) {
      throw new StripeResponseError(response, correlationId, data.error["message"], data.error["code"])
    } else {
      throw new Error(`Unexpected response from server: ${response.status}`)
    }
  }

  createJsonHeaders(correlationId: string): Headers {
    const headers = new Headers()
    headers.append("X-Request-ID", correlationId)
    headers.append("X-React-App-Version", __APP_VERSION__ || "local")
    headers.append("Content-Type", "application/json")
    headers.append("X-Authorizer-Domain", Settings.AUTHORIZER_DOMAIN)
    return headers
  }

  private async get<T>(url: URL): Promise<T> {
    const correlationId = uuid()

    const response = await fetch(url, {
      method: "GET",
      headers: this.createJsonHeaders(correlationId),
      credentials: "include"
    })

    return this.processJsonResponse(response, correlationId)
  }

  private async post<T>(url: URL, values: any): Promise<T> {
    const correlationId = uuid()

    const response = await fetch(url, {
      method: "POST",
      headers: this.createJsonHeaders(correlationId),
      credentials: "include",
      body: JSON.stringify({
        amount: values.amount,
        currency_code: values.currency_code,
        employee_id: values.employee_id,
        first_name: values.first_name,
        last_name: values.last_name,
        company_id: values.company_id,
        company_name: values.company_name,
        email: values.email
      })
    })

    return this.processJsonResponse(response, correlationId)
  }

  async generatePaymentIntent(values: PaymentIntentArgs): Promise<GeneratePaymentIntentResponse> {
    const url = new URL(`${Settings.INBOUND_MEMBER_PAYMENTS_BASE_URL}/generate-payment-intent`)
    return await this.post(url, values)
  }

  async getInvoices(expenseId: string): Promise<Invoice[]> {
    const url = new URL(`${Settings.INBOUND_MEMBER_PAYMENTS_BASE_URL}/get-invoices/${expenseId}`)
    return await this.get(url)
  }
}

export interface Invoice {
  status: string
  invoicePaymentUrl: string
  dateCreated: number
  datePaid: number
  expenseId: number
}
